import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const tableMapService = {
    getAll,
    getAllTableMaps,
    addTableMap,
    updateTableMap,
    deleteTableMap,
};

async function getAll(limit, offset, search_term, sort_column, sort_direction) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    
    const response = await fetch(
        `${config.oat_api_url}/manage/table-maps/getAllTableMaps/?limit=${limit}&offset=${offset}&search_term=${search_term}&sort_column=${sort_column}&sort_direction=${sort_direction}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllTableMaps() {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/table-maps/getAll/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function addTableMap(newTableMap) {
    const configOptions = {
        method: "POST",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(newTableMap),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/table-maps/add/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function updateTableMap(tableMapItem, tableMapId) {
    const configOptions = {
        method: "PUT",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(tableMapItem),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/table-maps/update/${tableMapId}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function deleteTableMap(id) {
    const configOptions = {
        method: "DELETE",
        headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/table-maps/delete/${id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}
